module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.1-124.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.6.1.md
// module id = 541
// module chunks = 263